import React from 'react';
import { useTranslation } from 'react-i18next';

function EditAction({ eleItem, handleAddUpdate, handleClose, isUploading }) {
  const { t } = useTranslation('common');

  return (
    <>
      <button
        title={t('CARE_LABELS.TABLE.EDIT_ACTION.SAVE')}
        disabled={isUploading}
        type="button"
        onClick={() => handleAddUpdate(eleItem)}
        className="filter-btn filter-button_delete"
      >
        <i className="icon-Save" />
      </button>
      <button title={t('CARE_LABELS.TABLE.EDIT_ACTION.CANCEL')} type="button" onClick={() => handleClose(eleItem)} className="filter-btn filter-button_delete">
        <i className="icon-cancel" />
      </button>
    </>
  );
}
export default EditAction;
